<footer>
    <div class="newsletter-area">
        <div class="container">
            <img src="assets/img/subscribe.jpg" alt="Shape">
            <h2>Want us to reach you back?</h2>

            <form class="newsletter-form">
                <input type="number" class="form-control" [(ngModel)]="phoneNumber" placeholder="Enter Your number" name="EMAIL" required autocomplete="off">
                <span *ngIf = "isInValid" style="color: red; font-size: 12px;">Please enter a valid number</span>
                <button class="btn contact-btn" type="button" (click)="reachMeBack()">Reach me back</button>
                <small>* You may seek a pro bono facility, please apply for legal aid.</small>
            </form>
        </div>
    </div>

    <div class="container">
        <div class="row">
            <div class="col-sm-6 col-lg-4">
                <div class="footer-item">
                    <div class="footer-logo">
                        <img src="assets/img/logo/logo.png" alt="Logo">
                        <img src="assets/img/logo/logo-text.png" alt="Logo">
                        <br /> <br />
                        <p>Our Attorneys are always here to provide you the best and efficient service. Still, if you want to know more about us and our firm, you can connect us through social media.</p>
                        <ul>
                            <!-- <li><a href="https://www.youtube.com/" target="_blank"><i class="icofont-youtube-play"></i></a></li> -->
                            <li><a href="https://www.facebook.com/Walayet-Associates-LLP-107271848527646" target="_blank"><i class="icofont-facebook"></i></a></li>
                            <li><a href="https://www.linkedin.com/in/walayetandassociates" target="_blank"><i class="icofont-linkedin"></i></a></li>
                            <li><a href="https://www.twitter.com/SAQIB_605" target="_blank"><i class="icofont-twitter"></i></a></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="col-sm-6 col-lg-3">
                <div class="footer-item">
                    <div class="footer-service">
                        <h3>Services</h3>

                        <ul>
                            <li><a (click) = "navigateToDetails('ADR Law')"><i class="icofont-simple-right"></i> ADR and Arbitration</a></li>
                            <li><a (click) = "navigateToDetails('Corporate Law')"><i class="icofont-simple-right"></i> Corporate and Securities</a></li>
                            <li><a (click) = "navigateToDetails('Banking Law')"><i class="icofont-simple-right"></i> Commercial and Banking</a></li>
                            <li><a (click) = "navigateToDetails('Litigation Law')"><i class="icofont-simple-right"></i> Litigation Group</a></li>
                            <li><a (click) = "navigateToDetails('ADR Law')"><i class="icofont-simple-right"></i> More...</a></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="col-sm-6 col-lg-2">
                <div class="footer-item">
                    <div class="footer-service">
                        <h3>Quick Links</h3>

                        <ul>
                            <li><a [routerLink]="routesUrl.homeUrl"><i class="icofont-simple-right"></i> Home</a></li>
                            <li><a [routerLink]="routesUrl.aboutUrl"><i class="icofont-simple-right"></i> About Us</a></li>
                            <li><a [routerLink]="routesUrl.attorneyUrl"><i class="icofont-simple-right"></i> Team</a></li>
                            <li><a [routerLink]="routesUrl.contactUrl"><i class="icofont-simple-right"></i> Appointment</a></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="col-sm-6 col-lg-3">
                <div class="footer-item">
                    <div class="footer-find">
                        <h3>Find Us</h3>

                        <ul>
                            <li class="custom-cursor"><i class="icofont-location-pin"></i> Office No 03, LG Sami Plaza, Opposite Lahore High Court, Rawalpindi Bench, Rawalpindi</li>
                            <li class="custom-cursor"><i class="icofont-ui-call"></i> <a href="tel:+923100022272">009 231 000 222 72</a></li>
                            <li><i class="icofont-at"></i> <a href="mailto:admin@walayetlaw.com"> admin@walayetlaw.com</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="copyright-area">
            <div class="row">
                <div class="col-sm-7 col-lg-6">
                    <div class="copyright-item">
                        <p>Copyright @2022 <strong>Walayet & Associates (LLP®)</strong>.<br /> Designed by <a href="https://hibootstrap.com/" target="_blank">HiBootstrap</a></p>
                    </div>
                </div>

                <div class="col-sm-5 col-lg-6">
                    <div class="copyright-item copyright-right">
                        <a [routerLink]="routesUrl.privacyPolicyUrl">Privacy Policy</a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="text-center" *ngIf="isLoading">
        <div class="spinner-border text-dark" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
</footer>
